import { Reveal } from "@/components/Reveal";
import { SectionParticles } from "@/components/SectionParticles";
import { scrollToId } from "@/lib/scroll";

const CHANGES = [
  "You will know which eligibility and entitlement questions must be verified instead of relying on online myths.",
  "You will understand the categories behind buying power and potential cash needed—without treating zero down as zero cost.",
  "You will be able to name your next three actions and choose whether to prepare, ask questions, or request an individual review.",
];

/* SECTION 9 — EMPATHY / TRANSFORMATION */
export const Transformation = () => (
  <section className="relative overflow-hidden px-5 md:px-10 lg:px-16 py-28 md:py-36 hairline-t" data-testid="transformation-section">
    <div
      aria-hidden="true"
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url(/assets/bg-home-5.jpg)" }}
    />
    <div
      aria-hidden="true"
      className="absolute inset-0"
      style={{ background: "linear-gradient(180deg, rgba(0,0,99,0.95), rgba(0,0,99,0.88), rgba(0,0,99,0.95))" }}
    />
    <SectionParticles variant="circles" />
    <div className="relative z-10 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 text-left">
      <div>
        <p className="font-mono text-[11px] tracking-[0.3em] text-[var(--muted)] mb-10">
          [006] — THE CHANGE
        </p>
        <Reveal>
          <h2 className="font-display font-semibold text-3xl md:text-4xl leading-tight text-white mb-8">
            If You Are Exploring a VA Home Loan for a Florida Purchase...
          </h2>
        </Reveal>
        <Reveal>
          <div className="space-y-5 text-base md:text-lg leading-relaxed text-[rgba(255,255,255,0.78)]">
            <p>
              Much of what circulates about VA financing arrives in one of two extremes: it is described as
              effortless, or it is dismissed as impossible. Then the real questions surface—entitlement,
              credit, cash categories, the funding fee, how sellers view the offer—and neither extreme has
              prepared anyone to answer them.
            </p>
            <p>
              That gap is frustrating, and it is not a reflection of the person asking. Everyone's situation
              is different, and this workshop does not presume to know yours. It exists to organize the
              questions—clearly, in order, without pressure—so that whatever you decide next is an informed
              decision rather than a reaction to noise.
            </p>
          </div>
        </Reveal>
      </div>
      <div className="lg:pt-20">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.24em] text-[var(--accent)] mb-8">
            HERE IS WHAT CHANGES AFTER THE WORKSHOP:
          </p>
        </Reveal>
        <div className="space-y-6 mb-12">
          {CHANGES.map((c, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="flex items-start gap-4 border-b border-[var(--line)] pb-6" data-testid={`transform-item-${i}`}>
                <span aria-hidden="true" className="font-mono text-[var(--accent)] shrink-0">→</span>
                <p className="text-sm md:text-base leading-relaxed text-[rgba(255,255,255,0.82)]">{c}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <button
          data-testid="transformation-cta-button"
          onClick={() => scrollToId("register")}
          className="glint bg-[var(--accent)] text-[var(--background-deep)] font-semibold text-sm tracking-[0.12em] px-8 py-4 rounded-[4px] hover:brightness-110 hover:-translate-y-[1px] transition-[transform,filter] duration-200"
        >
          GET THE WORKBOOK + SAVE MY SEAT
        </button>
      </div>
    </div>
  </section>
);
